import React from 'react';

import {
    RIQPopover
} from '../../../../components/RIQPopover.jsx';

import {
    listeningDefinitions
} from '../enums/listeningDefinitions.jsx';


export default function SearchTips() {
    return (
        <RIQPopover
            triggerNode={
                <button
                    className='tlw-border-0 tlw-bg-transparent tlw-text-blue-400'
                >
                    Search tips
                </button>
            }
            placement='bottom'
            additionalHookProps={{
                trigger: 'hover'
            }}
        >
            <SearchHintsPopover/>
        </RIQPopover>
    );
}

function SearchHintsPopover() {

    const {
        title,
        tipsListTips
    } = listeningDefinitions['search-tips'];

    return (
        <div>
            <Title
                title={title}
            />
            <TipsList
                tips={tipsListTips}
            />
        </div>
    );
}

function Tip({summary, detail}) {

    return (
        <div className='tlw-m-5'>
            <div className='tlw-font-bold tlw-text-gray-900'>{summary}</div>
            {detail}
        </div>
    );
}

function TipsList({tips}) {

    return (
        <div
            className='tlw-mx-5 tlw-my-8'
        >
            {tips.map((tip, i) => (
                <div
                    className={(i > 0 ? 'tlw-mt-7' : null)}
                    key={`tip-${i}`}
                >
                    <Tip
                        summary={tip.summary}
                        detail={tip.detail}
                    />
                </div>
            ))}
        </div>
    );
}

function Title({title}) {
    return (
        <div
            className='tlw-border-0 tlw-border-b tlw-border-solid tlw-border-gray-300 tlw-px-11 tlw-py-5'
        >
            <h3
                className='tlw-m-0 tlw-flex tlw-max-h-[43px] tlw-grow tlw-overflow-hidden tlw-text-ellipsis tlw-whitespace-nowrap tlw-text-base tlw-leading-22 tlw-text-gray-900'
            >
                <span className='tlw-min-w-0 tlw-overflow-hidden tlw-text-ellipsis'>
                    {title}
                </span>
            </h3>
        </div>
    );
}
